import { render } from "./FormInputRichText.vue?vue&type=template&id=d938c8bc"
import script from "./FormInputRichText.vue?vue&type=script&lang=js"
export * from "./FormInputRichText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__